import ReactDOM from "react-dom";
import React from "react";
import * as moment from "moment";
import * as _ from "lodash";
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"


import { UiUtils } from "../common/uiUtils";
import * as UploadReport from "../upload/uploadReport";
import { ViewerUtils } from "../common/viewerUtils";
import { ModelApi } from "../api/modelApi";
import ModelList from "./modelList";
import ComboModelForm from "./comboModelForm";
import ComboModelList from "./comboModelList";

interface ModelAnalytics {
    id: string;
    viewCount: number;
}

interface ProjectModel {
    models: any[];
    project: any;
    authenticated: boolean;
    hasAdminRole: boolean;
}

interface ProjectViewProps {
    projectModel: ProjectModel;
    multiModelOn: boolean;
    modelSettingsIds: any[];
}

interface ProjectViewState {
    comboModelEditOn: boolean;
}

interface ModelListProps {
    projectModel: ProjectModel;
    multiModelOn: boolean;
}

interface ModelListState {
    mainModel: string;
    subModels: string[];
    views: { [key: string]: number; };
    visitors: { [key: string]: number; };
}

interface ModelRowProps {
    model: any;
    index: number;
    mainChecked: boolean;
    subChecked: boolean;
    onMainChange: (evt) => void;
    onSubChange: (evt) => void;
    multiModelOn: boolean;
    viewCount: number;
    visitorCount: number;
    authenticated: boolean;
}

const ProjectInfo = (props) => {
    return <form>
               <div className="row">
                   <label className="col-sm-2 col-form-label">Name</label>
                   <div className="col-sm-10">
                       <span className="form-control-plaintext">{props.project.name}</span>
                   </div>
               </div>
               <div className="row">
                   <label className="col-sm-2 col-form-label">Id</label>
                   <div className="col-sm-10">
                       <span className="form-control-plaintext">{props.project.projectIdentifier}</span>
                   </div>
               </div>
               <div className="row">
                   <label className="col-sm-2 col-form-label">Customer</label>
                   <div className="col-sm-10">
                       <span className="form-control-plaintext">{props.project.customer}</span>
                   </div>
               </div>
               <div className="row">
                   <label className="col-sm-2 col-form-label">Manager</label>
                   <div className="col-sm-10">
                       <span className="form-control-plaintext">{props.project.manager}</span>
                   </div>
               </div>
               <div className="row">
                   <label className="col-sm-2 col-form-label">Expiration date</label>
                   <div className="col-sm-10">
                       <span className="form-control-plaintext">{moment(props.project.expirationDate)
                           .format("DD.MM.YYYY")
                       }</span>
                   </div>
               </div>
           </form>;
}

const latestRevisions = (models) => {
    const revisionGroups = _.groupBy(models, m => m.originalId);
    return _.values(revisionGroups).map(group => _.maxBy(group, (m: any) => m.revision));
}

class ProjectView extends React.Component<ProjectViewProps, ProjectViewState> {

    constructor(props) {
        super(props);
        this.state = { comboModelEditOn: false };
    }

    render() {
       
        return <DndProvider backend={HTML5Backend}>
            <div className="container-fluid pt-3">
                <div className="row">
                    <div className="col">
                        <h5>Project</h5>
                    </div>
                </div>
                <ProjectInfo project={this.props.projectModel.project} />
                <div key="buttons" className="row justify-content-start mb-3">
                    <div className="col-md-auto pr-1">
                        <button className="btn btn-primary" type="button" onClick={async () => {
                            const { data } = await ModelApi.getModels("default", this.props.projectModel.project.id);
                            UploadReport.createPdf(
                                ViewerUtils.baseUrl(),
                                this.props.projectModel.project.name,
                                latestRevisions(data))
                        }}>
                            <span className="icon ion-md-download mr-2"></span>PDF
                        </button>
                    </div>
                    <div className="col-md-auto px-0">
                        <button className="btn btn-primary" type="button" onClick={() => {
                            const uploadUrl =
                                `${ViewerUtils.sdUrl()}/upload?group=default&projectId=${this.props.projectModel.project.id
                                }`;
                            window.location.href = uploadUrl;
                        }}>
                            <span className="icon ion-md-cloud-upload mr-2"></span>Upload to project
                        </button>
                    </div>
                    <div className="col-md-auto pl-1">
                        <button className="btn btn-primary" type="button" disabled={this.state.comboModelEditOn} onClick={() => {
                            this.setState({ comboModelEditOn: true });
                        }}>
                            <span className="icon ion-md-business mr-2"></span>Create combined model
                        </button>
                    </div>
                </div>

                {this.state.comboModelEditOn && <ComboModelForm modelSettingsIds={this.props.modelSettingsIds}
                    projectId={this.props.projectModel.project.id}
                    submit={() => this.setState({ comboModelEditOn: false })}
                    cancel={() => this.setState({ comboModelEditOn: false })} />}
                {!this.state.comboModelEditOn && <ComboModelList
                    group="default"
                    projectId={this.props.projectModel.project.id}
                    authenticated={this.props.projectModel.authenticated}
                    enableDelete={this.props.projectModel.hasAdminRole}
                />}

                <ModelList projectModel={this.props.projectModel} />
            </div>
               </DndProvider>;
    }
}

function startProject(model, modelSettingsIds) {
    const multiModelOn = model.environment === "Local" || model.environment === "Development";
    ReactDOM.render(<ProjectView projectModel={model} multiModelOn={multiModelOn} modelSettingsIds={modelSettingsIds}/>,
        document.getElementById("project-view"));
}

export { startProject }